import { journalsServiceApi } from "@entities/api";

interface IUpdateRequestSigned {
  sectionFourListId: string;
  versionId: string;
  itemPartTwoId: string;
  updateRequest: {
    mainJournalId: string;
    section4Id: string;
    section4ListId: string;
    itemNoVersionId: string;
    companyId?: string;
    itemPartOne?: string; // id only
    itemPartTwo?: {
      defectFixingFactDate?: string;
      createOtherDocs?: {
        fileMetadata: {
          fileNumber: number;
          fileName: string;
          fileType: string;
          fileContentLength: number;
          id?: string;
          fileId?: string;
        };
        file?: File | Blob;
      }[];
      deleteOtherDocs?: { file: { id: string; fileId: string } }[];
      defectFixingInspectionEmployeeId?: string;
    };
    actionDetails: string;
  };
}

export async function updateSectionFourTwoRecordSigned({
  sectionFourListId,
  versionId,
  itemPartTwoId,
  updateRequest,
}: IUpdateRequestSigned) {
  const formData = new FormData();

  formData.append(
    "updateRequest",
    new Blob([JSON.stringify(updateRequest)], { type: "application/json" }),
  );

  updateRequest.itemPartTwo?.createOtherDocs?.forEach((doc) => {
    if (doc.file instanceof File || doc.file instanceof Blob) {
      formData.append("otherFiles", doc.file);
    }
  });

  const token = localStorage.getItem("token");

  const res = await journalsServiceApi.putForm(
    `/journals/section-four/${sectionFourListId}/items/${versionId}/itemPartTwo/${itemPartTwoId}/update`,
    formData,
    {
      headers: {
        "X-Auth": token || "",
      },
    },
  );

  return res.data;
}


